
    import React from 'react';
    import SpriteSymbol from "svg-baker-runtime/browser-symbol";
    import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
    import SpriteSymbolComponent from "../src/Icon.js";
    
    const symbol = new SpriteSymbol({
  "id": "start",
  "use": "start-usage",
  "viewBox": "0 0 91.333 85.167",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 91.333 85.167\" id=\"start\"><g fill=\"none\"><path d=\"M41.437 47.021h6.397c7.955-19.479 4.037-29.18-3.198-36.127-7.236 6.948-11.154 16.649-3.199 36.127zm6.841-22.603a3.643 3.643 0 11-7.287 0 3.644 3.644 0 017.287 0zM54.254 54.518c2.637-2.812 5.691-8.646-.651-14.992-.653 2.456-1.556 5.063-2.707 7.828 2.151 1.233 3.964 4.503 3.358 7.164zM35.017 54.518c-2.637-2.812-5.693-8.646.65-14.992.654 2.456 1.557 5.063 2.707 7.828-2.151 1.233-3.962 4.503-3.357 7.164zM46.015 49.843c.427 1.158 1.041 2.642.438 3.371-.602.734-1.82 1.509-1.82 1.509s-1.215-.772-1.815-1.509c-.603-.729.013-2.213.435-3.371-3.833 2.32-4.327 4.482-3.31 6.531.478.957 3.325 4.582 4.69 5.947 1.375-1.373 4.216-4.99 4.693-5.947 1.02-2.048.527-4.21-3.311-6.531z\" /></g></symbol>"
});
    sprite.add(symbol);

    export default class StartSpriteSymbolComponent extends React.Component {
      render() {
        return <SpriteSymbolComponent glyph="start" {...this.props} />;
      }
    }
  